import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default  function Edit(props:any) {
   
    return (

       <SvgIcon {...props}  viewBox="0 0 16 16">

         <path d="M9.82975 5.33333L10.6652 6.16889L2.5952 14.2222H1.77753V13.4044L9.82975 5.33333ZM13.0293 0C12.8071 0 12.576 0.0888889 12.4072 0.257778L10.7807 1.88444L14.1136 5.21778L15.74 3.59111C16.0867 3.24444 16.0867 2.66667 15.74 2.33778L13.6603 0.257778C13.4826 0.08 13.2604 0 13.0293 0ZM9.82975 2.83556L0 12.6667V16H3.33287L13.1626 6.16889L9.82975 2.83556Z" fill="currentColor"/>

       </SvgIcon>
    )
}